<template>
  <draggable class="fts-list-designer-layouter" 
    :class="{'list-designer-layouter-wrap': wrap}" 
    v-model="list.columns" 
    v-bind="dragOptions" 
    handle=".handle">
    <div class="list-designer-column" v-for="column in list.columns" :key="column.id">
      <fts-list-designer-element 
        :item="column" 
        :wrap="wrap" 
        :removeable="removeable" 
        @update="update"
        @remove="remove" />
    </div>
  </draggable>
</template>

<script>
import commons from "../commons/commons";
import draggable from "vuedraggable";

import FTSListDesignerElement from "./FTSListDesignerElement";

export default {
  props: {
    list: {
      type: Object,
      default: () => ({
        columns: []
      })
    },
    columns: {
      type: Array
    },
    wrap: {
      type: Boolean,
      default: true,
    },
    removeable: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    draggable,
    "fts-list-designer-element": FTSListDesignerElement,
  },
  data: () => ({
    dragOptions: commons.dragOptions,
  }),
  methods: {
    update(data) {
      const column = this.list.columns.find(x => x.id === data.id);
      this.$set(this.list.columns, this.list.columns.indexOf(column), data);
      this.$emit("input", data);
    },
    remove(data) {
      this.list.columns.splice(this.list.columns.indexOf(data), 1);
      this.$emit("input", data);
    }
  }
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-list-designer-layouter {
  display: flex;
  align-items: baseline;
  &.list-designer-layouter-wrap {
    flex-wrap: wrap;
    
  }
  &:not(.list-designer-layouter-wrap) {
    max-width: 100%;
    .list-designer-element-name {
      white-space: nowrap;
    }
  }
  // margin: -0.175rem;
  .list-designer-column {
    margin: .375rem 0;
    .list-designer-column-wrapper {
      // margin: 0 .175rem;
      // padding: .375rem;
      // background: #f5f5f5;
    }
  }
}

</style>